import React from 'react';

import PropTypes from 'prop-types';
import InfoButton from '../InfoButton';

export const SortType = {
    ASC: 'asc',
    DESC: 'desc',
};

const ColumnHeader = ({
    className = '',
    columnName,
    hoverText,
    initialSort = SortType.DESC,
    isSortable,
    isSelected,
    onClick,
    sortType,
    imgUrl,
    'data-testid': dataTestId,
}) => {
    const handleOnClick = (event) => {
        event.preventDefault();
        if (isSortable) {
            if (isSelected) {
                const updatedSortType = sortType === SortType.ASC ? SortType.DESC : SortType.ASC;
                onClick(updatedSortType);
            } else {
                onClick(initialSort);
            }
        }
    };

    const titleColor = isSelected ? 'text-teal' : 'text-dark';
    const image = isSelected && (sortType === SortType.ASC) ? 'uts-collapse' : 'uts-expand';

    return (
        <div
            className={`d-flex align-items-center cursor-pointer ${className} ${titleColor}`}
            onClick={handleOnClick}
            data-testid={dataTestId || undefined}
        >
            {columnName}
            {imgUrl && <img style={{ margin: '2px' }} src={imgUrl} data-testid={dataTestId && `${dataTestId}.img`} />}
            {isSortable && (
                <i className={`uts ${image}`} />
            )}
            {hoverText && <InfoButton hoverText={hoverText} />}
        </div>
    );
};
ColumnHeader.propTypes = {
    imgUrl: PropTypes.string,
    'data-testid': PropTypes.string,
};

ColumnHeader.defaultProps = {
    imgUrl: null,
    'data-testid': null,
};

export default ColumnHeader;
